import { useTranslation } from 'react-i18next';
import React, { useState, useCallback, useEffect } from 'react';

// Components
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Slide from '@mui/material/Slide';
import MUITextFieldStyle from '../MUIStyles/MUITextFieldStyle';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '../Alert';

// Queries
import postActualizarDomicilio from '../Queries/postActualizarDomicilio';
import AvalaraResolveAddress from '../Queries/AvalaraResolveAddress';

// Objects
import usStates from '../Queries/usStates';

// Styles
import styles from './index.module.sass';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

export default function AddressForm({
  setSessionMessage,
  history,
  getOrder,
  orderData,
  device,
  getCookie,
  webservice,
  callback,
  redirect = '',
  setAddressForm,
  extraShippingharge,
  t,
}) {
  const { domicilioEnvio = {} } = orderData || {};
  const isFinal = domicilioEnvio?.domicilioClienteFinalSN || '';

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [form, setForm] = useState(domicilioEnvio);
  const [nextRoute, setNextRoute] = useState('');
  const [checked, setChecked] = useState((isFinal === 'S' && true) || false);
  const [openWarning, setOpenWarning] = useState(false);
  const [notVerifiedChecked, setNotVerifiedChecked] = useState(false);

  const screenSize = device?.screenSize || 'desktop';

  const handleChange = (e, type) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheck = (event) => {
    setChecked(event.target.checked);
    if (event.target.checked) {
      setOpen(true);
      setAlertText(t('address:noGift'));
    }
  };

  const handelDialog = useCallback(
    (action, mensaje, route) => {
      if (mensaje) setAlertText(mensaje);
      setOpen(action);
      if (route) setNextRoute(route);
      if (!action && nextRoute) history.push(nextRoute);
      if (callback) callback();
    },
    [history, callback, nextRoute],
  );

  async function verifyAddress() {
    const resp = await AvalaraResolveAddress({
      jsonBody: {
        line1: form?.calle || '',
        line2: form?.entreCalle || '',
        city: form?.municipio || '',
        region: form?.estado || '',
        postalCode: form?.cp || '',
        country: 'US',
      },
    });

    const { message, tipoMensaje, validatedAddresses = [] } = resp;
    const { addressType = '' } = validatedAddresses[0] || {};
    if (addressType === 'POBoxAddress') {
      setAlertText('PO BOX addresses are not allowed');
      setOpen(true);
    } else if (
      notVerifiedChecked ||
      (tipoMensaje === 'success' && addressType !== 'POBoxAddress' && validatedAddresses[0])
    ) {
      const { city, line1, line2, region, postalCode } = validatedAddresses[0];

      // if (region === 'MT') {
      //   setAlertText(t('address:montanaAlert'));
      //   setOpen(true);
      // } else {
      setForm((oldValue) => {
        return {
          ...oldValue,
          calle: line1,
          entreCalle: line2,
          estado: region,
          colonia: region,
          municipio: city,
          ciudad: city,
          cp: postalCode,
        };
      });

      const response = await postActualizarDomicilio({
        jsonBody: {
          soloPaqueteria: 0,
          usuarioOK: getCookie('usuarioOk'),
          folioPedido: getCookie('folioPedido'),
          estado: region || '',
          calle: line1 || '',
          colonia: region || '',
          municipio: city || '',
          cp: postalCode || '',
          ocurre: extraShippingharge ? 1 : 0,
          paqueteria: 'FEDEX',
          entreCalle: line2 || '',
          yCalle: form?.yCalle || '',
          domicilioClienteFinalSN: (checked && 'S') || 'N',
          domicilioClienteFinalNombre: form?.domicilioClienteFinalNombre || '',
          domicilioClienteFinalTelefono: form?.domicilioClienteFinalTelefono || '',
          numeroExterior: form?.numeroExterior || '',
          numeroInterior: form?.numeroInterior || '',
          omitirValidacionDom: notVerifiedChecked,
        },
      });

      const { tipoMensaje = 'error', mensaje = '' } = response;

      setSessionMessage(mensaje);

      if (mensaje !== '498' && mensaje !== '499') handelDialog(true, mensaje, redirect);

      if (tipoMensaje === 'exito') {
        setForm({});
        window.scrollTo(0, 0);
        //setAddressForm(false);
      }

      return true;
    } else if (tipoMensaje === 'inspect') {
      // alert(tipoMensaje);
      handelDialog(true, message);
      return false;
    } else {
      // alert('Validation error');
      handelDialog(true, 'Validation error');
      return false;
    }
  }

  async function handleSubmit() {
    setLoading(true);

    await verifyAddress();

    setLoading(false);

    return true;
  }

  useEffect(() => {}, [form]);

  return (
    <div className={styles.AddressForm}>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handelDialog(false)}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <DialogContent>
          <div className={styles.dialogContent}>
            <div className={styles.dialogTitle}>{t('address:attention')}</div>
            {alertText}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handelDialog(false)} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Alert
        cancel
        open={openWarning}
        setOpen={setOpenWarning}
        title={t('address:warningText')}
        text={t('address:verifyWarning')}
        callback={() => {
          setNotVerifiedChecked(true);
        }}
      />

      <div className={`${styles.container} ${styles[screenSize]}`}>
        <div className={`${styles.inputContainer} ${styles.size50} ${styles.paddingRight}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-calle-input'
            label={t('address:address1')}
            type='text'
            name='calle'
            variant='outlined'
            value={form?.calle || ''}
            onChange={(e) => handleChange(e)}
            inputProps={{ maxLength: 40 }}
          />
        </div>

        {/* <div className={`${styles.inputContainer} ${styles.size50}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-numeroExterior-input'
            label={t('address:address2')}
            type='text'
            name='entreCalle'
            variant='outlined'
            value={form?.entreCalle || ''}
            onChange={(e) => handleChange(e)}
          />
        </div> */}

        <div className={`${styles.inputContainer}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-municipio-input'
            label={t('address:city')}
            type='text'
            name='municipio'
            variant='outlined'
            value={form?.municipio || ''}
            onChange={(e) => handleChange(e)}
          />
        </div>

        <div className={`${styles.inputContainer} ${styles.paddingRight}`}>
          <select
            className={styles.inputSelect}
            onChange={(e) => handleChange(e)}
            name='estado'
            maxLength='34'
            value={form?.estado || ''}>
            <option value=''>{t('address:state')}</option>
            {usStates.map((val, key) => {
              const { code = '', name = '' } = val;
              return (
                <option value={code} key={key}>
                  {name}
                </option>
              );
            })}
          </select>
        </div>

        <div className={`${styles.inputContainer} ${styles.size50}`}>
          <MUITextFieldStyle
            fullWidth
            id='outlined-cp-input'
            label={t('address:postalCode')}
            type='text'
            name='cp'
            variant='outlined'
            value={form?.cp || ''}
            onChange={(e) => handleChange(e)}
          />
        </div>

        <div className={styles.checkContainer}>
          <Checkbox checked={checked} onChange={handleCheck} />
          <span>{t('address:finalClient')}</span>
        </div>

        {checked && (
          <>
            <div className={`${styles.inputContainer} ${styles.paddingRight}`}>
              <MUITextFieldStyle
                fullWidth
                id='outlined-domicilioClienteFinalNombre-input'
                label={t('address:finalClientName')}
                type='text'
                name='domicilioClienteFinalNombre'
                variant='outlined'
                value={form?.domicilioClienteFinalNombre || ''}
                onChange={(e) => handleChange(e)}
              />
            </div>

            <div className={`${styles.inputContainer}  ${styles.paddingLeft}`}>
              <MUITextFieldStyle
                fullWidth
                id='outlined-domicilioClienteFinalTelefono-input'
                label={t('address:finalClientPhone')}
                type='number'
                name='domicilioClienteFinalTelefono'
                variant='outlined'
                value={form?.domicilioClienteFinalTelefono || ''}
                onChange={(e) => handleChange(e)}
                inputProps={{ maxLength: 10 }}
              />
            </div>
          </>
        )}
      </div>

      <div className={styles.formFooter}>
        <div className={styles.button}>
          <Button
            type='submit'
            variant='contained'
            size='large'
            color='primary'
            className={(loading && styles.disabled) || styles.actionButton}
            onClick={handleSubmit}
            disabled={loading}>
            {(loading && <CircularProgress className={styles.circularProgress} />) ||
              t('address:saveChanges')}
          </Button>
        </div>
        {/* <div className={styles.checkboxContainer}>
          <Checkbox
            checked={notVerifiedChecked}
            onClick={() => {
              if (!notVerifiedChecked) {
                setOpenWarning(true);
              } else {
                setNotVerifiedChecked(false);
              }
            }}
          />
          <span>{t('address:doNotVerify')}</span>
        </div> */}
      </div>
    </div>
  );
}
